export default __webpack_public_path__ + "static/media/Resure_icon.9edf5549.png";